export const REVERSE_GST_CHARGE_REPORT_REQUEST = 'REVERSE_GST_CHARGE_REPORT_REQUEST';
export const REVERSE_GST_CHARGE_REPORT_SUCCESS = 'REVERSE_GST_CHARGE_REPORT_SUCCESS';
export const REVERSE_GST_CHARGE_REPORT_FAILURE = 'REVERSE_GST_CHARGE_REPORT_FAILURE';